import React, { useEffect, useRef, useState } from 'react';
import './style.scss';
import Loader from '../../../components/general/loader';
import useAlert from '../../../contexts/alert';
import useArrayState from '../../../hooks/useArrayState';
import { API_GetOwnNftResponse, API_OwnNft } from 'shared';
import fetcher from '../../../utils/fetcher';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import PageError from '../../../components/general/error';
import FightPick from '../../../components/pages/fight/pick';
import Button from '../../../components/controls/button';
import { ejectErrorMessage } from '../../../utils/utils';

type Error = {
  status: boolean;
  message?: string;
};

const FightPagePick = () => {
  const alert = useAlert();
  const navigate = useNavigate();
  const firstLoad = useRef<boolean>(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error>({ status: false });
  const nfts = useArrayState<API_OwnNft>([]);

  useEffect(() => {
    getOwnNFTs()
      .then((response) => {
        nfts.setValue(response);
      })
      .catch(() => {
        /*do nothing*/
      })
      .finally(() => setLoading(false));
  }, []);

  const getOwnNFTs = () => {
    return new Promise<API_GetOwnNftResponse>((resolve, reject) => {
      fetcher.nft
        .getOwn()
        .then((response) => {
          if (firstLoad.current) {
            if (response.length === 0) {
              alert.show(
                'You’ve got to own a Nifty Hand to play🎮🤛. Mint one now',
                5000
              );
              resolve([]);
              return navigate('/market');
            }
            firstLoad.current = false;
          }
          resolve(response);
        })
        .catch((err) => {
          setError({ status: true, message: ejectErrorMessage(err) });
          reject(err);
        });
    });
  };

  return (
    <>
      {loading ? (
        <Loader useAbsoluteWrapper />
      ) : error.status ? (
        <PageError wording={error.message} />
      ) : nfts.value.length === 0 ? (
        <NoNft navigate={navigate} />
      ) : (
        <FightPick nfts={nfts} reload={getOwnNFTs} />
      )}
    </>
  );
};

interface NoNftProps {
  navigate: NavigateFunction;
}

const NoNft = ({ navigate }: NoNftProps) => (
  <div className='fight-pick-page-no-nft'>
    <h1 className='mb-20'>Where's NFT?</h1>
    <h4>You’ve got to own a Nifty Hand to play 🎮🤛</h4>
    <h4>
      Our super-smart app should have redirected you to market, but well...
    </h4>
    <Button onClick={() => navigate('/market')} className='no-nft-button'>
      Get NFT
    </Button>
  </div>
);

export default FightPagePick;
